var map = {
	"./de/warrior-name.png": "j9Ut",
	"./en/warrior-name.png": "M36r",
	"./es/warrior-name.png": "qhoH",
	"./fr/warrior-name.png": "9r5F",
	"./ja/warrior-name.png": "eVej",
	"./ko/warrior-name.png": "4k7a",
	"./pt/warrior-name.png": "3zVW",
	"./ru/warrior-name.png": "/I+p",
	"./th/warrior-name.png": "svWN",
	"./zh-Hant/warrior-name.png": "mfl8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vXLC";